/** Whose document on a fund-opening request is being replaced. */
export enum OpenFundRequestPersonRole {
  Coordinator = 'Coordinator',
  Supported = 'Supported',
}
